export default __webpack_public_path__ + "static/media/highlight.b57ef622.png";